import { HStack, Text, Tooltip, Icon, Box } from '@televet/kibble-ui';
import React from 'react';

const clientServiceFeeMessage =
  'The Client Service Fee is an additional charge added to the amount you want to collect from a client.';
interface IEditFeeItemProps {
  callToActionFunction?: (data: any) => void; //eslint-disable-line @typescript-eslint/no-explicit-any
  serviceFeePercentage: string | 0;
  clientServiceFee: string | 0;
}

const EditFeeItem = ({
  callToActionFunction,
  serviceFeePercentage,
  clientServiceFee,
}: IEditFeeItemProps): JSX.Element => {
  return (
    <HStack w="100%" pl={2}>
      <Text
        size="xs"
        fontWeight="bold"
        variant="subtle"
      >{`Client Service Fee (${serviceFeePercentage}%): $${clientServiceFee}`}</Text>
      <Tooltip label={clientServiceFeeMessage}>
        <Box>
          <Icon name="questionMarkCircle" size="xs" />
        </Box>
      </Tooltip>
      <Text size="xs" fontWeight="bold" textDecor="underline" cursor="pointer" onClick={callToActionFunction}>
        Edit Fee
      </Text>
    </HStack>
  );
};

export default EditFeeItem;
